import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/remote-config';

import 'firebase/auth';
import 'firebase/analytics';
import "firebase/performance";

const firebase_config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

export const db = firebase.initializeApp(firebase_config).firestore();

firebase.firestore().settings({ experimentalAutoDetectLongPolling: true });

const remoteConfig = firebase.remoteConfig();
remoteConfig.settings.minimumFetchIntervalMillis = 60000; // changed to 1 min

remoteConfig.defaultConfig = {
    hide_prepay_balance_if_zero: true,
    hide_prepay_topup: true,
    VUE_APP_IS_AFTERPAY_PAYMENT_MODULE_ALLOWED: false, //default value set to false
    VUE_APP_ENABLE_PROMO_CODE_MENU_ITEM: false,
    VUE_APP_IS_KLARNA_PAYMENT_MODULE_ALLOWED: false, // BNPL option - KLARNA
    VUE_APP_CP_SHOW_ADDON_IMAGES: true,
    VUE_APP_SHOW_CARRYOVER_PARAM: false,
    VUE_APP_MODULE_UFB_ENABLED: false,
    VUE_APP_CP_SHOW_DASHBOARD_WIDGET: "Hotspot,MMS,Data,Voice,SMS",
    VUE_APP_SHOW_HOTSPOT_PARAM: false,
    VUE_APP_CP_UFB_CHANGE_PLAN_MODE: "LATER", // NOW, LATER, BOTH defaulted to LATER as requested
    VUE_APP_CP_SHOW_PLANS_PASSWORD_POPUP: false,
    VUE_APP_CP_CONTROL_PASSWORD_STYLE: 1, // 1 = current per-MVNO password card; 2 = early-access copies ("You've been invited...") + visible title/subtitle modal layout, MVNO buttons/inputs unchanged. Only relevant when VUE_APP_CP_SHOW_PLANS_PASSWORD_POPUP is true.
    VUE_APP_CP_ENABLE_INVOICE_LINE_PERIOD: false,
    VUE_APP_CP_INVOICE_SHOW_INVOICE_PERIOD: false,
    // POI Verification - Document Type Visibility placeholder
    POI_SHOW_DRIVER_LICENSE: true, // For now always true, BE will handle this
    POI_SHOW_PASSPORT: true, // For now always true, BE will handle this
    VUE_APP_CP_IS_SHOW_ESIM_DOWNLOAD_URL: false,
    VUE_APP_CP_AVAILABLE_SIM_TYPES: "esim",
    VUE_APP_CP_SIMS_MULTI_PLANS_MEMBER_NAME: false,
    VUE_APP_CP_IS_NICKNAME_FIELD_MANDATORY: false,
    VUE_APP_CP_IS_TRIAL_MODE: false,
    VUE_APP_CP_SHOW_ESIM_ACTIVATION_TAB: false,
    VUE_APP_CP_SHOW_ESIM_DOWNLOAD_TAB_ON_CHECKOUT: false,
    VUE_APP_CP_ESIM_DOWNLOAD_STYLE_ON_CHECKOUT: 1,
    VUE_APP_CP_ENABLE_PURCHASE_PLANS_AND_ADDONS: true,
    VUE_APP_CP_TRAVEL_ESIM_ENABLED: false,
    VUE_APP_CP_SHOW_TRAVEL_PLAN_DESCRIPTION: false,
    VUE_APP_CP_AVAILABLE_SSO_TYPES: "none",
    VUE_APP_CP_ENABLE_USAGE_BREAKDOWN: false,
    VUE_APP_CP_STATUS_BADGE_CASING: "uppercase",
};

export const auth = firebase.auth;

let analytics = null
let perf = null

if (process.env.VUE_APP_HAS_FIREBASE_ANALYTICS == 'true') {
    const google_analytics_link = document.createElement('link')
    google_analytics_link.rel = 'preconnect'
    google_analytics_link.href = 'https://www.google-analytics.com'

    document.getElementsByTagName('head')[0].appendChild(google_analytics_link)

    analytics = firebase.analytics();
}

if (process.env.VUE_APP_HAS_FIREBASE_PERFORMANCE == 'true') {
    perf = firebase.performance();
}

export { analytics };
export { perf };
export const fb_remote_config = remoteConfig;
